import type { FlattenSimpleInterpolation } from 'styled-components'
import styled, { css } from 'styled-components'

import { advancedSpacing, respondTo } from '@vfuk/core-mixins'

import type { StyledAlertNotificationProps } from './AlertNotification.style.types'

export const AlertNotification = styled.div(
  (): FlattenSimpleInterpolation => css`
    display: flex;
    flex-direction: column;
  `,
)

export const IconWrapper = styled.div(
  (props: StyledAlertNotificationProps): FlattenSimpleInterpolation => css`
    background: ${props.theme.color[props.state!].default};
    display: flex;
  `,
)

export const NotificationHeader = styled.div((props: StyledAlertNotificationProps): FlattenSimpleInterpolation => {
  const iconSize = props.theme.getIconProperties('system').size[2].sm

  return css`
    flex: 1;
    text-align: center;
    margin-left: ${props.closeButton ? `${iconSize}px` : '0'};
    margin-bottom: 0;
    ${advancedSpacing('padding', [2, 2, 2])}
  `
})

export const ContentWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    ${advancedSpacing('padding', [3])}
    display: flex;
    flex-direction: column;
    flex: 1;
  `,
)

export const NotificationWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    width: 100%;
    display: flex;
  `,
)

export const CloseButton = styled.div(
  (): FlattenSimpleInterpolation => css`
    ${advancedSpacing('margin', [3, 3, 1])}
    padding: 0;
  `,
)

export const ButtonWrapper = styled.div(
  (): FlattenSimpleInterpolation => css`
    ${respondTo.md(css`
      margin-left: auto;
    `)}
  `,
)
